/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { newKioskAuthOptionButtonSchema } from "./newKioskAuthOptionButtonSchema.ts";

export const newKioskAuthOptionsSchema = z
	.object({
		auth_choice_text: z.string(),
		buttons: z.array(newKioskAuthOptionButtonSchema),
	})
	.describe("Сериализатор блока выбора способа авторизации на киоске.");
